export function MoneySendEmpty({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="200"
        height="152"
        viewBox="0 0 200 152"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M128 24C121.333 29.3333 117.667 36.3333 117 45"
          stroke="var(--clr-title)"
          strokeOpacity="0.2"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeDasharray="1 7"
        />
        <path
          d="M120 104C136.569 104 150 90.5685 150 74C150 57.4315 136.569 44 120 44C103.431 44 90 57.4315 90 74C90 90.5685 103.431 104 120 104Z"
          fill="var(--clr-container-bg)"
          stroke="var(--clr-border-grey-100)"
        />
        <path
          d="M120.382 83.312C119.152 83.312 118.042 83.078 117.054 82.61C116.084 82.142 115.269 81.5267 114.61 80.764C113.969 80.0013 113.51 79.178 113.232 78.294L114.74 77.748C115.226 79.0653 115.945 80.0707 116.898 80.764C117.869 81.4573 119.022 81.804 120.356 81.804C121.24 81.804 122.012 81.6567 122.67 81.362C123.346 81.0673 123.875 80.6513 124.256 80.114C124.638 79.5767 124.828 78.944 124.828 78.216C124.828 77.2107 124.542 76.4307 123.97 75.876C123.416 75.3213 122.688 74.9227 121.786 74.68L118.25 73.64C116.812 73.224 115.746 72.5567 115.052 71.638C114.376 70.702 114.038 69.6447 114.038 68.466C114.038 67.4433 114.281 66.5507 114.766 65.788C115.269 65.008 115.945 64.4013 116.794 63.968C117.644 63.5347 118.606 63.318 119.68 63.318C120.807 63.318 121.812 63.5347 122.696 63.968C123.598 64.384 124.352 64.9387 124.958 65.632C125.582 66.308 126.024 67.062 126.284 67.894L124.802 68.44C124.369 67.244 123.702 66.3427 122.8 65.736C121.899 65.112 120.868 64.8 119.706 64.8C118.944 64.8 118.259 64.9473 117.652 65.242C117.046 65.5367 116.569 65.9527 116.222 66.49C115.876 67.0273 115.702 67.66 115.702 68.388C115.702 69.272 115.954 70.026 116.456 70.65C116.959 71.274 117.8 71.768 118.978 72.132L122.15 73.068C123.537 73.484 124.603 74.1253 125.348 74.992C126.111 75.8413 126.492 76.89 126.492 78.138C126.492 79.1607 126.232 80.062 125.712 80.842C125.192 81.6047 124.464 82.2113 123.528 82.662C122.61 83.0953 121.561 83.312 120.382 83.312ZM119.472 85.6V61.03H120.98V85.6H119.472Z"
          fill="var(--clr-general-primary)"
        />
        <path
          d="M78 146C101.196 146 120 127.196 120 104C120 80.804 101.196 62 78 62C54.804 62 36 80.804 36 104C36 127.196 54.804 146 78 146Z"
          fill="var(--clr-container-bg)"
          stroke="var(--clr-border-grey-100)"
        />
        <path
          d="M64 97C68 101.667 72 101.667 76 97"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          d="M84 97C88 101.667 92 101.667 96 97"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          d="M72 111C77.3333 115 82.6667 115 88 111"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          opacity="0.18"
          d="M58.5 109.5C60.1569 109.5 61.5 108.157 61.5 106.5C61.5 104.843 60.1569 103.5 58.5 103.5C56.8431 103.5 55.5 104.843 55.5 106.5C55.5 108.157 56.8431 109.5 58.5 109.5Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.18"
          d="M98.5 109.5C100.157 109.5 101.5 108.157 101.5 106.5C101.5 104.843 100.157 103.5 98.5 103.5C96.8431 103.5 95.5 104.843 95.5 106.5C95.5 108.157 96.8431 109.5 98.5 109.5Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.9"
          d="M131 18.9994C135.665 13.5006 141.984 13.7693 144.599 19.2612C139.383 22.8376 134.025 22.2932 131 18.9994Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.65"
          d="M131 18.9998C127.424 13.7835 129.89 7.87466 135.658 6.22083C137.312 11.9884 135.531 16.6604 131 18.9998Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.45"
          d="M148 125L150 130L155 132L150 134L148 139L146 134L141 132L146 130L148 125Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.4"
          d="M47.9999 43.6004C49.4358 43.6004 50.5999 42.4363 50.5999 41.0004C50.5999 39.5644 49.4358 38.4004 47.9999 38.4004C46.564 38.4004 45.3999 39.5644 45.3999 41.0004C45.3999 42.4363 46.564 43.6004 47.9999 43.6004Z"
          fill="var(--clr-general-primary)"
        />
      </svg>
    </span>
  );
}
